/**
 * @desc 客户归属渠道(平台),数据权限使用
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.OwnershipChannelResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/common/ownershipChannelList/datapermission`, {
      method: "GET",

      ...options,
    }),
  );
}
